export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST' as const;
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS' as const;
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR' as const;

export const GET_BRANCHES_REQUEST = 'GET_BRANCHES_REQUEST' as const;
export const GET_BRANCHES_SUCCESS = 'GET_BRANCHES_SUCCESS' as const;
export const GET_BRANCHES_ERROR = 'GET_BRANCHES_ERROR' as const;

export const GET_USER_BRANCHES_REQUEST = 'GET_USER_BRANCHES_REQUEST' as const;
export const GET_USER_BRANCHES_SUCCESS = 'GET_USER_BRANCHES_SUCCESS' as const;
export const GET_USER_BRANCHES_FAILURE = 'GET_USER_BRANCHES_FAILURE' as const;

export const SET_BRANCH_TITLE = 'SET_BRANCH_TITLE' as const;
